import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { EVENT_NAMES } from '@go-modules/services/event/event-names.constants';
import { EventService } from '@go-modules/services/event/event.service';
import { LtiService, ReloadResponse } from '@lti/app/services/lti/lti.service';
import { BehaviorSubject } from 'rxjs';

@Component({
	selector: 'iframe-banner',
	templateUrl: './iframe-banner.component.html',
	styleUrls: ['./iframe-banner.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class IframeBannerComponent {
	@Output() public bannerClosed = new EventEmitter<void>();
	public iframeBannerClosed$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	public constructor (
		@Inject('Window') private window: Window,
		private ltiService: LtiService,
		private eventService: EventService
	) {
		this.eventService.listen(EVENT_NAMES.LTI_APP_DATA_UPDATED).subscribe(() => {
			this.closeBanner();
		});

		const appData = sessionStorage.getItem('appData');
		if (!appData || !JSON.parse(appData).signature) {
			this.closeBanner();
		}
	}

	public closeBanner () {
		this.bannerClosed.emit();
		this.iframeBannerClosed$.next(true);
	}

	public goFullscreen () {
		// Open a placeholder tab immediately to avoid popup blocking
		const newTab = this.window.open('about:blank', '_blank');
		if (!newTab) {
			// The popup was blocked. Do nothing here and let the browser inform the user
			// by showing the "popup blocked" message in the url bar. This shouldn't happen.
			return;
		}
		const appData = sessionStorage.getItem('appData');
		this.ltiService.reload(JSON.parse(appData)).subscribe({
			next: (response: ReloadResponse) => {
				newTab.location.href = response.url;
			}
		});
	}
}
